import { Navigate, Route, Routes } from 'react-router-dom'
import { getAuthState } from './auth'
import { ArcCreatePage } from './pages/ArcCreate'
import { ArcEditPage } from './pages/ArcEdit'
import { ArcsPage } from './pages/Arcs'
import { AuditHistoryPage } from './pages/AuditHistory'
import { EntitiesPage } from './pages/Entities'
import { EntityEditPage } from './pages/EntityEdit'
import { EventsPage } from './pages/Events'
import { MessagesPage } from './pages/Messages'
import { NotAuthedPage } from './pages/NotAuthed'
import { NotFoundPage } from './pages/NotFound'
import { TtsPage } from './pages/Tts'
import { WikiPage } from './pages/Wiki'
import {
  WikiArcSummaryEditPage,
  WikiChallengeSummaryEditPage,
  WikiEntityPageCreatePage,
  WikiEntityPageEditPage,
} from './pages/WikiEdit'
import { XSourceEntriesPage } from './pages/XSourceEntries'

export default function App() {
  const auth = getAuthState()

  if (!auth.authenticated) {
    return (
      <Routes>
        <Route path="*" element={<NotAuthedPage />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/entities" replace />} />
      <Route path="/entities" element={<EntitiesPage />} />
      {/* CP17 Phase 2 — narrow entity edit form (4 fields). */}
      <Route path="/entities/:id/edit" element={<EntityEditPage />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/wiki" element={<WikiPage />} />
      {/* CP10 Phase 3 — admin wiki write surfaces. Each route is a page
          component that renders inside the shared <Shell>. Order
          matters: the more-specific `/wiki/arcs/:id/edit` and
          `/wiki/challenges/:id/edit` are declared before the generic
          `/wiki/:id/edit` so react-router picks the narrowest match
          first. */}
      <Route path="/wiki/new" element={<WikiEntityPageCreatePage />} />
      <Route path="/wiki/arcs/:id/edit" element={<WikiArcSummaryEditPage />} />
      <Route path="/wiki/challenges/:id/edit" element={<WikiChallengeSummaryEditPage />} />
      <Route path="/wiki/:id/edit" element={<WikiEntityPageEditPage />} />
      {/* CP13 Phase 1 — TTS moderation queue (read + per-row review-state
          flip). Single page, no sub-routes. */}
      <Route path="/tts" element={<TtsPage />} />
      {/* CP14 Phase 1 — Production Messages moderation queue (read +
          per-row review-state flip with required hide_reason). Single
          page, no sub-routes. */}
      <Route path="/messages" element={<MessagesPage />} />
      {/* CP15 Phase 1 — X-Source entries moderation queue. Same shape
          as /messages narrowed to review_state + page filters (no
          author_handle, no since). Single page, no sub-routes. */}
      <Route path="/x-source" element={<XSourceEntriesPage />} />
      {/* CP16 Phase 1 — read-only audit-history view over
          `mutation_events`. No write affordances. */}
      <Route path="/audit-history" element={<AuditHistoryPage />} />
      {/* Refinement Phase A1 — top-level Arcs admin surface.
          Replaces the `Arcs (soon)` shell placeholder. */}
      {/* Refinement Phase A2 — arc create form. Order matters:
          `/arcs/new` must come before `/arcs/:id/edit` so the
          literal "new" is not interpreted as an id. */}
      <Route path="/arcs/new" element={<ArcCreatePage />} />
      {/* Refinement Phase A3 — arc full-row edit form. */}
      <Route path="/arcs/:id/edit" element={<ArcEditPage />} />
      <Route path="/arcs" element={<ArcsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
